import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';

/**
 * Generated class for the NuevoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-cliente',
  templateUrl: 'cliente.html',
})
export class ClientePage {
  cliente: any = {}
  codigo: any = ''
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public https : HttpProvider,
    public viewCtrl : ViewController
    ) {
      this.codigo = this.navParams.get('cliente')
      if(window.localStorage.getItem('network') === '1'){
        this.https.get(`cliente/cli/${this.codigo}`).subscribe(
          (res:any)=>{
            this.cliente = res
          },
          error=>console.log(error)
        )
      }
  }

  close(){
    this.viewCtrl.dismiss()
  }

}



// WEBPACK FOOTER //
// ./src/pages/cliente/ciente.ts